import React from 'react';
import { Card as MuiCard, CardProps as MuiCardProps } from '@mui/material';

export const Card = ({ children, ...props }: MuiCardProps) => {
  return (
    <MuiCard elevation={0} sx={{ borderRadius: 2, border: '1px solid', borderColor: 'divider' }} {...props}>
      {children}
    </MuiCard>
  );
};
